(function () {  // SortBy
  document.addEventListener('DOMContentLoaded', function(){
    const url = new URL(location);
    url.searchParams.set("filter.v.availability", "1");
    url.toString();
    var elem = document.getElementById('SortBy');
    // var result = elem.value;
    var paramUrl = location.search;
    // var param = paramUrl.split('=');
    // console.log('param',paramUrl);
   
    if( paramUrl == '?sort_by=product-available' ) {
      url.searchParams.delete("sort_by");
      location.search = '?filter.v.price.gte=&filter.v.price.lte=&filter.v.availability=1';
      paramUrl.replace( '?sort_by=product-available', '?filter.v.availability=1' );
    };
  }, false);

  // サイドバーのいちをスクロールにあわせる
  window.addEventListener('scroll', function(){
    if (window.scrollY > 250) {
      if(document.getElementById('index-sidebar')) {
        document.getElementById('index-sidebar').classList.add('sticky');
      } else if(document.getElementById('CollectionSidebar')) {
        document.getElementById('CollectionSidebar').parentElement.classList.add('sticky');
      }
    } else {
      if(document.getElementById('index-sidebar')) {
        document.getElementById('index-sidebar').classList.remove('sticky');
      } else if(document.getElementById('CollectionSidebar')) {
        document.getElementById('CollectionSidebar').parentElement.classList.remove('sticky');
      }
    }
  });

  // メルマガ登録時に、すでに登録れてる場合にエラーをだす
  // var urlParam = location.search.substring(1);
 
  // if(urlParam) {
  //   var param = urlParam.split('&');
  //   var paramArray = [];
  //   for (i = 0; i < param.length; i++) {
  //     var paramItem = param[i].split('=');
  //     paramArray[paramItem[0]] = paramItem[1];
  //   }
  //   if (paramArray.form_type == 'customer') {
  //     document.getElementById("error-newsletter-customer").classList.add("old-subscriber-true");
  //   } else {
  //     document.getElementById("error-newsletter-customer").classList.remove("old-subscriber-true");
  //   }
  // }
  
  // 郵便番号検索
  if (document.URL.match(/account/)) {
    var zipCode = document.getElementById('AddressZipNew');
    var pregion = document.getElementById('pregion');
          
    zipCode.onchange = function () {
      var provinceData = document.getElementById("AddressProvinceNew");

      var options = provinceData.options;
      for(var i = 0; i < options.length; i++){
        if(options[i].text === pregion.value){
          options[i].selected = true;
          break;
        };
      };
    }

    var form = document.querySelectorAll('.address-edit-toggle');
    // var formID = form.dataset.formId;
    // console.log('formID', form)
    form.forEach(function (item, index) {
      item.onclick = function () {
        // console.log('this',this)
        // console.log(this.dataset.formid);
        var formid = this.dataset.formid;
        // console.log(index);
      
        
        var pregionEdit = document.getElementById('pregionEdit');
        // console.log("provinceDataEdit", options)
      
        var zipCodeEdit = document.getElementById("AddressZip_" + formid);
              // console.log('zipCodeEdit',zipCodeEdit)
        zipCodeEdit.onchange = function () {
          var provinceDataEdit = document.getElementById("AddressProvince_" + formid);

          var options = provinceDataEdit.options;
          for(var i = 0; i < options.length; i++){
            if(options[i].text === pregionEdit.value){
              options[i].selected = true;
              break;
            };
          };
        }
      }
    });
  }

  if (document.URL.match(/collections/)) {
    if(document.querySelector('.linkactive')) {
      var element = document.querySelector('.linkactive');
      var elementArialabel = element.getAttribute('aria-controls');
      var spElementArialabel = elementArialabel.replace( 'CollectionSidebar', 'SidebarDrawer' );
      // var elementCollapssedId = element.closest(elementArialabel);
      var elementCollapssed = document.getElementById(elementArialabel);
      var spElementCollapssed = document.getElementById(spElementArialabel);
      var collapssedBtn = elementCollapssed.previousElementSibling;
      var spCollapssedBtn = spElementCollapssed.previousElementSibling;
  
      elementCollapssed.classList.add('is-open');
      collapssedBtn.classList.add('is-open');
      spElementCollapssed.classList.add('is-open');
      spCollapssedBtn.classList.add('is-open');
    }
  }
})();